import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "panel" }
const _hoisted_3 = { class: "button__container" }
const _hoisted_4 = { class: "button__container" }

import { onMounted, ref } from 'vue'
import { SolarSystem } from '../main/SolarSystem'


export default /*@__PURE__*/_defineComponent({
  __name: 'SolarSystem',
  setup(__props) {

const solarSystem = ref<SolarSystem>();

onMounted(() => {
    const canvas = document.querySelector('canvas')!;
    solarSystem.value = new SolarSystem(canvas);
})

function togglePause(event: Event) {
  if (!solarSystem.value) return;

  const target = event.target as HTMLInputElement;
  if (solarSystem.value.isPaused) {
    solarSystem.value.resumeSimulation();
    target.textContent = '||';
  } else {
    solarSystem.value.pauseSimulation();
    target.textContent = '►';
  }
}

function changeSimulationSpeed(event: Event) {
  const target = event.target as HTMLInputElement;
  solarSystem.value?.changeSimulationSpeed(Number(target.value));
}

function focusOn(event: Event) {
  const target = event.target as HTMLInputElement;
  solarSystem.value?.changeCameraTarget(target.dataset.name ?? '');
}

function toggleOrbits(event: Event) {
  solarSystem.value?.toggleOrbits((event.target as HTMLInputElement).checked);  
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Global settings", -1)),
      _createElementVNode("div", { class: "button__container" }, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Play/Pause simulation", -1)),
        _createElementVNode("button", {
          onClick: togglePause,
          id: "play-pause"
        }, "||")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Simulation speed", -1)),
        _createElementVNode("input", {
          onInput: changeSimulationSpeed,
          type: "range",
          min: "0",
          max: "1000000",
          step: "10000",
          id: "simulation-speed"
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Enable orbits", -1)),
        _createElementVNode("input", {
          onChange: toggleOrbits,
          type: "checkbox",
          value: "orbits",
          checked: "",
          id: "orbits"
        }, null, 32)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Camera settings", -1)),
      _createElementVNode("button", {
        class: "planet__element",
        onClick: focusOn,
        "data-name": "free"
      }, "Free camera"),
      _cache[6] || (_cache[6] = _createTextVNode(" Focus on: ")),
      _createElementVNode("div", { id: "planets-list" }, [
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "sun"
        }, "Sun"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "mercury"
        }, "Mercury"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "venus"
        }, "Venus"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "earth"
        }, "Earth"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "mars"
        }, "Mars"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "jupiter"
        }, "Jupiter"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "saturn"
        }, "Saturn"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "uranus"
        }, "Uranus"),
        _createElementVNode("button", {
          class: "planet__element",
          onClick: focusOn,
          "data-name": "neptune"
        }, "Neptune")
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", null, [
        _createElementVNode("i", null, [
          _createTextVNode(" The sizes of planets are 10 times bigger than actual sizes compared to sun. "),
          _createElementVNode("br"),
          _createTextVNode(" The simulation is not an exact representation of the solar system. ")
        ])
      ], -1))
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("canvas", null, null, -1))
  ]))
}
}

})